import { CoverBackground } from 'components/CoverBackground'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'

const Wrapper = styled.div`
  padding: 72px 0 0 0;
`

const Suptitle = styled.h6`
  margin-bottom: 12px;
  color: #0078c9;
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  text-transform: uppercase;
  text-align: center;
`

const Title = styled.h1`
  margin-bottom: 8px;
  font-size: 26px;
  font-weight: bold;
  line-height: 37px;
  text-align: center;
`

const Subtitle = styled.p`
  margin-bottom: 40px;
  color: #22262a;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
`

const Photo = styled(CoverBackground)`
  border-radius: 10px;
  height: 0;
  padding-bottom: 65%;
`

const ContactTitle = styled.h5`
  margin: 0;
  padding: 32px 0 20px 0;
  color: #22262a;
  font-size: 17px;
  font-weight: bold;
  line-height: 22px;
`

const Item = styled.div`
  padding: 20px 0;
`

const ItemTitle = styled.h6`
  margin-bottom: 24px;
  color: #0078c9;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-transform: uppercase;
`

const ItemText = styled.p`
  margin-bottom: 14px;
  color: #22262a;
  font-size: 16px;
  line-height: 23px;
`

export const IntroMobile: ComponentType = () => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <Suptitle>Contáctanos</Suptitle>
          <Title>Oficinas Yucatán Premier</Title>
          <Subtitle>Desde el 2008 trabajamos activamente en el posicionamiento de este sitio web</Subtitle>
          <Photo url="/images/offices-photo.jpg" />
        </Col>
      </Row>
      <Row>
        <Col>
          <ContactTitle>Información de Contacto</ContactTitle>
          <Item>
            <Row>
              <Col>
                <ItemTitle>Ventas</ItemTitle>
                <ItemText as="a" href="tel:9999441214">
                  999 944-1214
                </ItemText>
              </Col>
              <Col>
                <ItemTitle>Rentas</ItemTitle>
                <ItemText as="a" href="tel:9999441213">
                  999 944-1213
                </ItemText>
              </Col>
            </Row>
          </Item>
          <Item>
            <ItemTitle>Email general</ItemTitle>
            <ItemText as="a" href="mailto:info@yucatanpremier.com">
              info@yucatanpremier.com
            </ItemText>
          </Item>
          <Item>
            <ItemTitle>Horarios de atención</ItemTitle>
            <ItemText>
              <strong>Lunes a viernes,</strong> de 9:00 am a 7:00 pm
            </ItemText>
            <ItemText>
              <strong>Sábados,</strong> de 9:00 am a 7:00 pm
            </ItemText>
          </Item>
          <Item>
            <ItemTitle>Dirección</ItemTitle>
            <ItemText>
              Calle 22 No.248 x 27-A <br />
              Fracc. Monterreal <br />
              Mérida, Yucatán, México 97133
            </ItemText>
          </Item>
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
